export default __webpack_public_path__ + "static/media/Wild.7efa85d4.png";